/* eslint-disable react-native/no-inline-styles */
/**
 * @author TankNee 2020-07-30
 * @class BottomPopExplanation
 * @description word解释弹框
 */
import React, { Component, PureComponent } from "react";
import _ from "lodash";
import Video from "react-native-video";
import hoistStatics from "hoist-non-react-statics";
import MDIcon from "react-native-vector-icons/MaterialIcons";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Platform, ScrollView, StyleSheet, TouchableOpacity, View, TextInput } from "react-native";
import { Button, Text } from "native-base";
import { WebView } from "react-native-webview";
import Icon from "react-native-vector-icons/Ionicons";
import Modal from 'react-native-modal';
import DefaultService from "../../services/screens/studyletter/DefaultService";
import LetterStateManager from "../../utils/LetterStateManager";
import * as Helper from "../../utils/Helper";
import UIDs from "../../UIDs";
import RBSheet from "./RBSheet";
import TranslationText from "./TranslationText";
import Word from "./Word";
import Letter from "./Letter";
import LoadingIndicator from "./LoadingIndicator";
import MessageBox from "../../components/ui/MessageBox";
import CrawlService from "../../services/screens/word/CrawlService";
import FeedbackSuggestionService from "../../services/screens/me/FeedbackSuggestionService";
import { getBottomPopExplanationBaseHtml } from "../../utils/HanziWriterHelper";
import { NavigationService } from "../../navigation";

import Dimensions from "react-native-web-dimension-helper";

const uid = UIDs.components.ui.bottompopexplanation;

const { width, height } = Dimensions.get("window");

const isIos = Platform.OS === "ios";

class BottomPopExplanationInstance extends Component {
    static BottomPopExplanationInstanceE;

    static handleWordExplanationSheet(word) {
        if (this.BottomPopExplanationInstanceE) {
            this.BottomPopExplanationInstanceE._handleWordExplanationSheet(word);
        }
    }

    static handleLetterExplanationSheet(letter) {
        if (this.BottomPopExplanationInstanceE) {
            this.BottomPopExplanationInstanceE._handleLetterExplanationSheet(letter);
        }
    }

    static handleNoData(word) {
        if (this.BottomPopExplanationInstanceE) {
            this.BottomPopExplanationInstanceE._handleNoData(word);
        }
    }

    Explanation = null;

    constructor(props) {
        super(props);
        this.state = {
            wordData: null,
            letterData: null,
            wordDataList: [],
            paused: true,
            audioPath: "",
            isNoData: false,
            isFetchingData: false,
            showReportError: false,
            showChangeState: false,
            isChangedState: false,
            reportErrorCode: 0,
            description: "",
            height:1,
        };
    }

    onContentSizeChange(event) {
        this.setState({height: event.nativeEvent.contentSize.height});
    }

    renderReason(reason, index) {
        const selected = (this.state.reportErrorCode === reason.code);
        return (<Button key={index} style={{height: 40, backgroundColor: (selected ? "#cc0000" : "#eee"),
                                            marginRight: 8, marginBottom: 8,
                                            borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                        transparent onPress={() => {
                            this.setState({
                                    reportErrorCode: selected ? -1 : reason.code,
                                    description: "",
                                });
                        }}
                >
                    <Text style={{color: selected ? '#fff' : '#666'}}>{reason.text}</Text>
                </Button>);
    }

    _sendReportError() {
        let reportAPI = null;
        let id = null;
        if (this.state.wordData && this.state.wordData.origin && this.state.wordData.origin.chars) {
            reportAPI = FeedbackSuggestionService.reportWordError;
            id = this.state.wordData.origin.chars.join("");
        }
        else if (this.state.letterData && this.state.letterData.origin && this.state.letterData.origin.char) {
            reportAPI = FeedbackSuggestionService.reportLetterError;
            id = this.state.letterData.origin.char;
        }

        if (reportAPI) {
            reportAPI({id: id, errorCode: this.state.reportErrorCode, description: this.state.description},
                      (response) => {
                          this.setState({showReportError: false, reportErrorCode: 0, description: ""});
                          MessageBox.success({
                              text: this.props.t("reportSuccess"),
                              duration: 5000
                          });
                      },
                      (response) => {
                          this.setState({showReportError: false, reportErrorCode: 0, description: ""});
                          MessageBox.danger({
                              text: this.props.t("reportError"),
                              duration: 5000
                          });
                      });
        }
        else {
            this.setState({showReportError: false, reportErrorCode: 0, description: ""});
        }
    }

    renderReportError() {
        const reasons = [
            {code: 0, text: this.props.t('hasError')},
            {code: 1, text: this.props.t('interpretError')},
            {code: 2, text: this.props.t('phoneticError')},
            {code: 3, text: this.props.t('pronounceError')},
            {code: 4, text: this.props.t('exampleError')},
            {code: 5, text: this.props.t('exampleInterpretError')},
            {code: 6, text: this.props.t('otherError')},
        ];
        return (<View style={{zIndex: 10, position: 'absolute', left: 0, top: 40, right: 0, bottom: 0,
                              backgroundColor: '#fff', paddingLeft: 20, paddingRight: 20, paddingBottom: 20}}>
                    <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                        <Text style={{fontSize: 20}}>
                            {this.props.t("reportWordError")}
                        </Text>
                    </View>
                    <View style={{marginTop: 20, flexDirection: 'row', flexWrap: "wrap"}}>
                        {reasons.map((reason, index) => {
                            return this.renderReason(reason, index);
                        })}
                    </View>
                    <View style={{flex: 1,}}>
                        {
                            this.state.reportErrorCode === 6 ?
                                <TextInput ref={"description"}
                                    multiline={true}
                                    onContentSizeChange={this.onContentSizeChange.bind(this)}
                                    onChangeText={text => this.setState({ description: text })}
                                    placeholder={this.props.t("otherErrorDescription")}
                                    value={this.state.description}
                                    placeholderTextColor={"#666666"}
                                    style={{borderWidth:1, width:"100%", borderRadius:6, borderColor:"#0099FF", padding:10, height:Math.max(25,this.state.height),}}
                                />
                            : null
                        }
                    </View>
                    <View style={{flexDirection: 'row'}}>
                        <Button style={{flex: 1, height: 40, backgroundColor: (this.state.reportErrorCode >= 0) ? "#1E90FF" : "#ccc",
                                        marginRight: 8,
                                        borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                                disabled={this.state.reportErrorCode < 0}
                                transparent onPress={() => {
                                    this._sendReportError();
                                }}
                        >
                            <Text style={{color: '#fff'}}>{this.props.t('submit')}</Text>
                        </Button>
                        <Button style={{flex: 1, height: 40, backgroundColor: "#fff", marginLeft: 8,
                                        borderColor: '#333', borderWidth: 1,
                                        borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                                transparent onPress={() => {
                                    this.setState({showReportError: false, reportErrorCode: 0});
                                }}
                        >
                            <Text style={{color: '#333'}}>{this.props.t('cancel')}</Text>
                        </Button>
                    </View>
                </View>);
    }

    render() {
        let letterState = 0;
        if(this.state.letterData && this.state.letterData.origin && this.state.letterData.origin.char){
            letterState = LetterStateManager.instance().letterState(this.state.letterData.origin.char);
        }else if(this.state.wordData && this.state.wordData.origin && this.state.wordData.origin.chars){
            for(var i=0; i<this.state.wordData.origin.chars.length;i++){
                let oneChar = this.state.wordData.origin.chars[i];
                let getState = LetterStateManager.instance().letterState(oneChar);
                if( getState >= LetterStateManager.StatePassed){
                    letterState = getState;
                    break;
                }
            }
        }

        return (
            <RBSheet
                ref={ref => {
                    this.Explanation = ref;
                }}
                closeOnDragDown
                dragFromTopOnly
                expandOnDrag
                openDuration={0}
                closeDuration={0}
                height={height * 0.5}
                customStyles={{
                    container: {
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                    },
                    draggableIcon: {
                        margin: 15,
                    },
                }}
                isLoading={this.state.isFetchingData}
                onClose={this._onRBClose}
                renderLoadingComponent={h => (
                    <View style={[styles.container, styles.centerAlign, { height: h }]}>
                        <LoadingIndicator useNativeLoading={"pop"} />
                    </View>
                )}>
                <Video
                    key={isIos ? this.state.audioPath : undefined /* 解决ios bug: https://github.com/react-native-video/react-native-video/pull/650 */}
                    audioOnly={true}
                    paused={this.state.paused}
                    source={{ uri: Helper.convertToAbsoluteUrl(this.state.audioPath) }} // Can be a URL or a local file.
                    ref={self => {
                        this.player = self;
                    }} // Store reference
                    onEnd={() => {
                        this.setState({ paused: true }, () => {
                            this.player.seek(0);
                            // this.processUnitDone();
                        });
                    }}
                    style={{ width: 1, height: 1 }}
                />
                {this.state.showReportError ? this.renderReportError() : null}
                <ScrollView>
                    <View style={styles.listContainer}>
                        {this.state.wordData && this.state.wordData.origin && this.state.wordData.origin.chars && !this.state.letterData ? (
                            <View>
                                <View style={{ ...styles.itemMargin, display: "flex", flexDirection: "row", alignItems: "center", borderBottomWidth: 1, borderBottomColor: "#ebebebeb" }}>
                                    {this.state.wordDataList.length > 1 ? <Button transparent
                                        onPress={() => {
                                            this.state.wordDataList.splice(this.state.wordDataList.length-1,1);
                                            this.setState({
                                                wordDataList: this.state.wordDataList,
                                                wordData: this.state.wordDataList[this.state.wordDataList.length - 1]
                                            })
                                        }}
                                    >
                                        <MDIcon name="arrow-back" size={25} color={"#333"} style={{ marginRight: 5, alignSelf: "center" }} />
                                    </Button>: null}
                                    <Button transparent
                                        onPress={() => {
                                            this._handlePlayWordAudio();
                                        }}
                                    >
                                        <MDIcon name="volume-up" size={25} color={"#F9C66A"} style={{ marginRight: 5, alignSelf: "center" }} />
                                    </Button>
                                    <Word
                                        data={this.state.wordData.origin}
                                        style={{
                                            lineHeight: 25,
                                            fontSize: 21,
                                            marginBottom: 15,
                                            flexWrap: "wrap",
                                            //flex:5,
                                            marginTop: this.state.wordDataList.length > 1 ? -8 : null
                                        }}
                                        onLetterPress={letter => {
                                            this._handleLetterExplanationSheet(letter);
                                        }}
                                    />
                                    {this.state.wordData.origin.chars?<a onClick={()=>this.Explanation.close()} href={"http://www.iciba.com/word?w=" + this.state.wordData.origin.chars.join("")} target="_blank" style={{textDecoration:"none"}}>
                                        <Icon name="ios-search" style={{ fontSize:20, color:"#989898", marginLeft: 4}}/>
                                    </a>:null}
                                    <View style={{flex: 1}}/>
                                    <TouchableOpacity
                                        onPress={() => {
                                            this._handleReportError();
                                        }}
                                    >
                                        <Icon name="ios-help-circle-outline" style={styles.issueIcon} />
                                        {/*<View style={{borderWidth: 1, borderRadius: 4,
                                                      borderColor: "#F9C66A",
                                                      alignItems: 'center', justifyContents: 'center',
                                                      paddingLeft: 4, paddingRight: 4,
                                                      paddingTop: 0, paddingBottom: 0}}>
                                            <Text style={{fontSize: 13, color: "#F9C66A"}}>{this.props.t('error')}</Text>
                                        </View>*/}
                                    </TouchableOpacity>
                                    {letterState >= LetterStateManager.StatePassed && !this.state.isChangedState ? <TouchableOpacity
                                        style={{marginLeft:30}}
                                        onPress={() => {
                                            this._handleChangeState();
                                        }}
                                    >
                                        <Icon name="ios-trash" style={{...styles.issueIcon, color:"red"}} />
                                    </TouchableOpacity>: null}
                                </View>
                                {this.state.isNoData && (
                                    <View>
                                        <View>
                                            <Text style={styles.itemTitleStyle}>{this.props.t("noData")}</Text>
                                        </View>
                                    </View>
                                )}
                                {this.state.wordData.explanation ? (
                                    <View style={styles.itemMargin}>
                                        <View>
                                            <Text style={styles.itemTitleStyle}>{this.props.t("translation")}</Text>
                                        </View>
                                        <TranslationText style={styles.itemTextStyle}>{Helper.translateChinese(this.state.wordData.explanation)}</TranslationText>
                                    </View>
                                ) : null}
                                {this.state.wordData.synonym && !Helper.isNullOrEmpty(this.state.wordData.synonym) && (
                                    <View style={styles.itemMargin}>
                                        <View>
                                            <Text style={styles.itemTitleStyle}>{this.props.t("synonym")}</Text>
                                        </View>
                                        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                                            {this.state.wordData.synonym.map((synonym, index) => {
                                                let charsSynonym = {"chars":synonym.split(""), syllables: Array.from({ length: synonym.split("").length }, () => "")};
                                                return (
                                                    <View key={index} style={{ marginRight: 5, marginTop: -20 }}>
                                                        <Word
                                                            data={charsSynonym}
                                                            style={{...styles.itemTextStyle, paddingTop:0,}}
                                                        />
                                                    </View>
                                                );
                                            })}
                                        </View>
                                    </View>
                                )}
                                {this.state.wordData.antonym && !Helper.isNullOrEmpty(this.state.wordData.antonym) && (
                                    <View style={styles.itemMargin}>
                                        <View>
                                            <Text style={styles.itemTitleStyle}>{this.props.t("antonym")}</Text>
                                        </View>
                                        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                                            {this.state.wordData.antonym.map((antonym, index) => {
                                                let charsAntonym = {"chars":antonym.split(""), syllables: Array.from({ length: antonym.split("").length }, () => "")};
                                                return (
                                                    <View key={index} style={{ marginRight: 5, marginTop: -20  }}>
                                                        <Word
                                                            data={charsAntonym}
                                                            style={{...styles.itemTextStyle, paddingTop:0,}}
                                                        />
                                                    </View>
                                                );
                                            })}
                                        </View>
                                    </View>
                                )}
                                {this.state.wordData.sentences && !Helper.isNullOrEmpty(this.state.wordData.sentences) && (
                                    <View style={styles.itemMargin}>
                                        <View>
                                            <Text style={styles.itemTitleStyle}>{this.props.t("sentences")}</Text>
                                        </View>
                                        <View>
                                            {this.state.wordData.sentences.map((explanation, index) => {
                                                return (
                                                    <View key={index} style={{ marginBottom: 4, display: "flex", flexDirection: "row", alignItems: "flex-start", flexWrap: "wrap" }}>
                                                        <Text style={{ ...styles.itemTextStyle, alignSelf: "flex-start", marginRight: 3 }}>{`${index + 1}.`}</Text>
                                                        <View style={{ flex: 1 }}>
                                                            <TranslationText style={styles.itemTextStyle}>{Helper.translateChinese(explanation)}</TranslationText>
                                                            <View style={{flexDirection: "row", alignItems: "flex-start", flexWrap: "wrap" }}>
                                                                {_.split(explanation.zh, this.state.wordData.chars.join("")).map((item, index, arr) => {
                                                                    return (
                                                                        <React.Fragment key={index}>
                                                                            {item.split("").map((c, i)=>
                                                                                <Word
                                                                                    data={{chars: c.split(''), syllables: ['']}}
                                                                                    pinyinVisible={false}
                                                                                    style={{...styles.itemTextStyleContent, marginTop:1}}
                                                                                />
                                                                            )}
                                                                            {index < arr.length - 1 && (
                                                                                this.state.wordData.chars.join("").split('').map((c, i)=>
                                                                                    <Word
                                                                                        data={{chars: c.split(''), syllables: ['']}}
                                                                                        pinyinVisible={false}
                                                                                        style={{...styles.itemTextStyleContent, marginTop:1, /*color: "#ff7057"*/}}
                                                                                    />
                                                                                )
                                                                            )}
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                            </View>
                                                        </View>
                                                    </View>
                                                );
                                            })}
                                        </View>
                                    </View>
                                )}
                            </View>
                        )
                        : this.state.letterData && this.state.letterData.origin && this.state.letterData.origin.char ? (
                            <View>
                                <View style={{ ...styles.itemMargin, display: "flex", flexDirection: "row", alignItems: "center", borderBottomColor: "#E8E9E8", borderBottomWidth: 1 }}>
                                    {this.state.wordData ? <MDIcon
                                        name="arrow-back"
                                        size={25}
                                        style={{ marginRight: 5 }}
                                        onPress={() => {
                                            this.setState({ letterData: null });
                                        }}
                                    />: null}
                                    <Letter
                                        data={this.state.letterData.origin}
                                        style={{
                                            lineHeight: 25,
                                            fontSize: 21,
                                            marginBottom: 15,
                                        }}
                                        enableLearnedPinyin = {false}
                                    />
                                    <a onClick={()=>this.Explanation.close()} href={"http://www.iciba.com/word?w=" + this.state.letterData.origin.char} target="_blank" style={{textDecoration:"none"}}>
                                        <Icon name="ios-search" style={{ fontSize:20, color:"#989898", marginLeft: 4}}/>
                                    </a>
                                    <View style={{flex: 1}}/>
                                    <TouchableOpacity
                                        onPress={() => {
                                            this._handleReportError();
                                        }}
                                    >
                                        <Icon name="ios-help-circle-outline" style={styles.issueIcon} />
                                        {/*<View style={{borderWidth: 1, borderRadius: 4,
                                                      borderColor: "#F9C66A",
                                                      alignItems: 'center', justifyContents: 'center',
                                                      paddingLeft: 4, paddingRight: 4,
                                                      paddingTop: 0, paddingBottom: 0}}>
                                            <Text style={{fontSize: 13, color: "#F9C66A"}}>{this.props.t('error')}</Text>
                                        </View>*/}
                                    </TouchableOpacity>
                                    {letterState >= LetterStateManager.StatePassed && !this.state.isChangedState ? <TouchableOpacity
                                        style={{marginLeft:30}}
                                        onPress={() => {
                                            this._handleChangeState();
                                        }}
                                    >
                                        <Icon name="ios-trash" style={{...styles.issueIcon, color:"red"}} />
                                    </TouchableOpacity>: null}
                                </View>
                                {this.state.letterData.definitions && (
                                    <View>
                                        <View style={styles.itemMargin}>
                                            <Text style={[styles.itemTitleStyle]}>{this.props.t("definitions")}</Text>
                                        </View>
                                        {this.state.letterData.definitions.map((definition, index) => {
                                            return (
                                                <View key={index}>
                                                    <View style={{ ...styles.itemMargin, display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                        <MDIcon
                                                            name="volume-up"
                                                            size={25}
                                                            color={"#F9C66A"}
                                                            style={{ marginRight: 5, alignSelf: "center" }}
                                                            onPress={() => {
                                                                this.setState(
                                                                    {
                                                                        audioPath: `~/fs/dictionary/pinyin/${definition.pinyin}.mp3`,
                                                                    },
                                                                    () => {
                                                                        this._handlePlayAudio();
                                                                    }
                                                                );
                                                            }}
                                                        />
                                                        <Text style={(styles.itemTitleStyle, { color: "#000" })}>{Helper.convertToPinyin(definition.pinyin)}</Text>
                                                    </View>
                                                    <View style={{ ...styles.itemMargin, backgroundColor: "#f9f9f9", borderRadius: 5 }}>
                                                        {definition.explanations && !Helper.isNullOrEmpty(definition.explanations) && (
                                                            <View>
                                                                {definition.explanations.map((explanation, explanationIndex) => {
                                                                    return (
                                                                        <View
                                                                            key={explanationIndex}
                                                                            style={{
                                                                                ...styles.itemStyle,
                                                                                paddingTop: explanationIndex === 0 ? 5 : 0,
                                                                                display: "flex",
                                                                                flexDirection: "row",
                                                                                alignItems: "flex-start",
                                                                                flexWrap: "wrap",
                                                                            }}>
                                                                            {/*<Text style={{ ...styles.itemTextStyle, alignSelf: "flex-start", marginRight: 3 }}>{`${explanationIndex + 1}.`}</Text>*/}
                                                                            <View style={{ flex: 1 }}>
                                                                                {explanation.characteristic && explanation.characteristic.zh && explanation.characteristic.en ? (
                                                                                    <Text style={[styles.itemTextStyle, {color:"#000"}]}>
                                                                                        {this.props.t("characteristic", { en: Helper.translateChinese(explanation.characteristic), zh:explanation.characteristic.zh })}
                                                                                    </Text>
                                                                                ) : null}
                                                                                {explanation.semantics && !Helper.isNullOrEmpty(explanation.semantics) && (
                                                                                    <View style={{ display: "flex",}}>
                                                                                        {explanation.semantics.length > 0 ? <View style={{flex:1 }}><Text style={[styles.itemTextStyle, {color:"#000"}]}>1. {this.props.t("meanings")}</Text></View>: null}
                                                                                        <View style={{flexDirection: "row", alignItems: "flex-start", flexWrap: "wrap" }}>
                                                                                        {explanation.semantics.map((semantics, semanticsIndex) => {
                                                                                            let meanings = Helper.translateChinese(semantics.meaning).replace(":", "").split(";");
                                                                                            let meaningZhs = semantics.meaning ? semantics.meaning.zh.split(";") : [];
                                                                                            meanings = meanings.map((m, i) => {
                                                                                                let mz = (meaningZhs[i] || "").trim();
                                                                                                m = m.trim();
                                                                                                return !Helper.isNullOrEmpty(mz) ? `${m}(${mz})` : m;
                                                                                            });
                                                                                            let s = meanings.join("; ");
                                                                                            if (semanticsIndex < explanation.semantics.length - 1) s = s + "; ";
                                                                                            return s.split("").map((t, i) => (
                                                                                                <TranslationText key={"Translation" + i} style={styles.itemTextStyleContent}>
                                                                                                    {t}
                                                                                                </TranslationText>
                                                                                            ));
                                                                                        })}
                                                                                        </View>
                                                                                    </View>
                                                                                )}
                                                                                {explanation.semantics && !Helper.isNullOrEmpty(explanation.semantics) && (
                                                                                    <View>
                                                                                        {explanation.semantics.length > 0 ? <View style={{flex:1 }}><Text style={[styles.itemTextStyle, {color:"#000"}]}>2. {this.props.t("examples")}</Text></View> : null}
                                                                                        <View style={{flexDirection: "row", alignItems: "flex-start", flexWrap: "wrap" }}>
                                                                                        {explanation.semantics.map((semantics, semanticsIndex) => {
                                                                                            return semantics.examples && semantics.examples.map((example, exampleIndex)=>(
                                                                                                <View key={semanticsIndex + "Translation" + exampleIndex} style={{flexDirection:"row", marginRight:5, flexWrap: "wrap"}}>
                                                                                                    <Text style={[styles.itemTextStyleContent, {flexWrap: "wrap"}]}>{Helper.translateChinese(example).replace(";", " ")} (</Text>
                                                                                                    {example.zh && example.zh.split("").map((c, i)=>
                                                                                                        <Word
                                                                                                            data={{chars: c.split(''), syllables: ['']}}
                                                                                                            pinyinVisible={false}
                                                                                                            style={{...styles.itemTextStyleContent, marginTop:1}}
                                                                                                        />
                                                                                                    )}
                                                                                                    <Text style={[styles.itemTextStyleContent]}>) ;</Text>
                                                                                                </View>
                                                                                            ))
                                                                                        })}
                                                                                        </View>
                                                                                    </View>
                                                                                )}
                                                                            </View>
                                                                        </View>
                                                                    );
                                                                })}
                                                            </View>
                                                        )}
                                                    </View>
                                                </View>
                                            );
                                        })}
                                    </View>
                                )}
                                {this.state.letterData.sentences && !Helper.isNullOrEmpty(this.state.letterData.sentences) && (
                                    <View style={styles.itemMargin}>
                                        <View>
                                            <Text style={styles.itemTitleStyle}>{this.props.t("sentences")}</Text>
                                        </View>
                                        <View style={styles.itemStyle}>
                                            {this.state.letterData.sentences.map((explanation, index) => {
                                                return (
                                                    <View key={index} style={{ marginBottom: 4, display: "flex", flexDirection: "row", alignItems: "flex-start", flexWrap: "wrap" }}>
                                                        <Text style={{ ...styles.itemTextStyle, alignSelf: "flex-start", marginRight: 3 }}>{`${index + 1}.`}</Text>
                                                        <View style={{ flex: 1 }}>
                                                            <TranslationText style={styles.itemTextStyle}>{Helper.translateChinese(explanation)}</TranslationText>
                                                            <View style={{flexDirection: "row", alignItems: "flex-start", flexWrap: "wrap" }}>
                                                                {/*explanation.zh*/}
                                                                {_.split(explanation.zh, this.state.letterData.origin.char).map((item, index, arr) => {
                                                                    return (
                                                                        <React.Fragment key={index}>
                                                                            {item.split("").map((c, i)=>
                                                                                <Word
                                                                                    data={{chars: c.split(''), syllables: ['']}}
                                                                                    pinyinVisible={false}
                                                                                    style={{...styles.itemTextStyleContent, marginTop:1}}
                                                                                />
                                                                            )}
                                                                            {index < arr.length - 1 && (
                                                                                <Word
                                                                                    data={{chars: this.state.letterData.origin.char.split(''), syllables: ['']}}
                                                                                    pinyinVisible={false}
                                                                                    style={{...styles.itemTextStyleContent, marginTop:1, /*color: "#ff7057"*/}}
                                                                                />
                                                                            )}
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                            </View>
                                                        </View>
                                                    </View>
                                                );
                                            })}
                                        </View>
                                    </View>
                                )}
                                <View style={styles.itemMargin}>
                                    <View>
                                        <Text style={styles.itemTitleStyle}>{this.props.t("letterGif")}</Text>
                                    </View>
                                    <View style={[styles.itemStyle]}>
                                        {this.state.letterData ? (
                                            <WebView
                                                source={{ html: getBottomPopExplanationBaseHtml().replace("%char%", this.state.letterData.origin.char), baseUrl: "web/" }}
                                                style={{ height: 160, width: 130 }}
                                                mixedContentMode="always"
                                                originWhitelist={["*"]}
                                                ref={webView => (this.webView = webView)}
                                            />
                                        ) : null}
                                    </View>
                                </View>
                            </View>
                        )
                        : <View style={{flex:1, justifyContent:"center", alignItems:"center"}}><Text>{this.props.t("errorData")}</Text></View>}
                    </View>
                    <Modal isVisible={this.state.showChangeState} style={{justifyContent:"center", alignItems:"center"}}>
                       <View style={{width: 400, overflow: 'hidden',
                                     flexDirection: 'column', borderRadius: 10, backgroundColor: '#fff'}}>
                           <View style={{flexDirection: 'row', height: 60,
                                         alignItems: 'center', justifyContent: 'center'}}>
                               <Text>{this.props.t("changeState")}</Text>
                               <TouchableOpacity style={{position: 'absolute', top: 7, right: 16}} onPress={() => {
                                   this._handleCancelChangeState()
                               }}>
                                   <Icon name="ios-close" style={{ fontSize: 46, color:"#999999", marginRight: 0 }}/>
                               </TouchableOpacity>
                           </View>
                           <View style={{alignItems:"center", padding:20}}>
                                <Text style={{color:"#b6b6b6"}}>{this.props.t("changeStateInfo")}</Text>
                           </View>
                           <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center", height:80}}>
                                <Button transparent onPress={() => { this._handleSendChangeState()}}>
                                   <View style={{minWidth:100, height: 40, backgroundColor: '#0c80ff', marginRight:20,
                                                 borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}>
                                       <Text style={{fontSize: 18, color: '#fff'}}>{this.props.t("changeStateSubmit")}</Text>
                                   </View>
                               </Button>
                               <Button transparent onPress={() => { this._handleCancelChangeState()}}>
                                      <View style={{minWidth:100, height: 40, backgroundColor: '#0c80ff',
                                                    borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}>
                                          <Text style={{fontSize: 18, color: '#fff'}}>{this.props.t("cancel")}</Text>
                                      </View>
                                </Button>
                           </View>
                       </View>
                   </Modal>
                </ScrollView>
            </RBSheet>
        );
    }

    _onRBClose = () => {
        if (this.state.isFetchingData) {
            //reset fetching status when you close the modal
            this.setState({ isFetchingData: false });
        }
        this.setState({
            wordData: null,
            wordDataList:[],
            letterData: null,
            audioPath: "",
            paused: true,
            showChangeState: false,
            isChangedState: false,
        })
    };

    _handleWordExplanationSheet = async word => {
        this.Explanation.open();
        this.setState({ isFetchingData: true, showReportError: false, reportErrorCode: 0 });
        CrawlService.getWordDetails(
            { id: word.chars.join("") },
            async response => {
                if(response && response.wordDetails && response.wordDetails.wordInfo) {
                    if (this.state.isFetchingData) {
                        let wordData = response.wordDetails.wordInfo;
                        let wordDataList = this.state.wordDataList;
                        if(Helper.isNullOrEmpty(word.syllables[0])){
                            word.syllables = wordData.syllables;
                        }
                        wordDataList.push({ ...wordData, origin: word, useNewPath: true });
                        this.setState(
                            {
                                isFetchingData: false,
                                wordData: { ...wordData, origin: word, useNewPath: true },
                                wordDataList: wordDataList,
                                letterData: null,
                                isNoData: false,
                            },
                            () => {
                                this._handlePlayWordAudio(true);
                            }
                        );
                    }
                } else {
                    this._handleNoData(word);
                }
            },
            error => {
                this._handleNoData(word);
            }
        );

        /*const basePath = Helper.convertToAbsoluteUrl("~/fs/dictionary/word/data");
        const fileName = Helper.getUnicodeOfChineseChar(word.chars, "-");
        const firstCharCode = Helper.getUnicodeOfChineseChar(word.chars[0], "");
        //const oldPath = `${basePath}/${fileName}.json`;
        const newPath = `${basePath}/${firstCharCode}/${fileName}.json`;

        await fetch(newPath, {cache: "no-cache"}).then(async newResponseData => {
            if (newResponseData.status === 200) {
                const wordData = await newResponseData.json();
                if (this.state.isFetchingData) {
                    let wordDataList = this.state.wordDataList;
                    wordDataList.push({ ...wordData, origin: word, useNewPath: true });
                    this.setState(
                        {
                            isFetchingData: false,
                            wordData: { ...wordData, origin: word, useNewPath: true },
                            wordDataList: wordDataList,
                            letterData: null,
                            isNoData: false,
                        },
                        () => {
                            this._handlePlayWordAudio(true);
                        }
                    );
                }
            } else {
                CrawlService.crawlWord(
                    { id: word.chars.join(""), pinyin: word.syllables.join(" ") },
                    async response => {
                        await fetch(newPath).then(async responseTemp => {
                            if (responseTemp.status === 200) {
                                const wordData = await responseTemp.json();
                                if (this.state.isFetchingData) {
                                    let wordDataList = this.state.wordDataList;
                                    wordDataList.push({ ...wordData, origin: word, useNewPath: true });
                                    this.setState(
                                        {
                                            isFetchingData: false,
                                            wordData: { ...wordData, origin: word, useNewPath: true },
                                            wordDataList: wordDataList,
                                            letterData: null,
                                            isNoData: false,
                                        },
                                        () => {
                                            this._handlePlayWordAudio(true);
                                        }
                                    );
                                }
                            } else {
                                this._handleNoData(word);
                            }
                        });
                    },
                    error => {
                        this._handleNoData(word);
                    }
                );
            }
        });*/
    };

    _handleLetterExplanationSheet = async letter => {
        this.Explanation.open();
        this.setState({ isFetchingData: true, showReportError: false, reportErrorCode: 0 });
        const basePath = Helper.convertToAbsoluteUrl("~/fs/dictionary/letter");
        const fileName = Helper.getUnicodeOfChineseChar(letter.char, "");
        CrawlService.getLetterDetails(
            { id: letter.char },
            async response => {
                if(response && response.letterDetails && response.letterDetails.letterInfo) {
                    let letterData = response.letterDetails.letterInfo;
                    if(Helper.isNullOrEmpty(letter.pinyin)){
                        letter.pinyin = letterData.definitions[0] ? letterData.definitions[0].pinyin : "";
                    }
                    this.setState(
                        {
                            isFetchingData: false,
                            letterData: { ...letterData, origin: letter, gifSrc: `${basePath}/${fileName}/${fileName}.gif` },
                        }
                    );
                } else {
                    this._handleNoData(letter);
                }
            },
            error => {
                this._handleNoData(letter);
            }
        );

        /*
        const response = await fetch(`${basePath}/${fileName}/${fileName}.json`);
        const letterData = await response.json();
        this.setState(
            {
                isFetchingData: false,
                letterData: { ...letterData, origin: letter, gifSrc: `${basePath}/${fileName}/${fileName}.gif` },
            },
            () => {
                this.Explanation.open();
            }
        );*/
    };

    _handleNoData = word => {
        if (this.state.isFetchingData) {
            this.setState(
                {
                    isFetchingData: false,
                    wordData: { origin: word },
                    letterData: null,
                    isNoData: true,
                },
                () => {
                    this._handlePlayWordAudio();
                }
            );
        }
    };

    _handleReportError = () => {
        this.setState({showReportError: true, reportErrorCode: 0});
    };

    //将通过改为待学习状态
    _handleChangeState = () => {
        this.setState({showChangeState: true});
    }

    _handleCancelChangeState = () => {
        this.setState({showChangeState: false});
    }

    _handleSendChangeState = () => {
        let reportAPI = null;
        let id = [];
        let strChangeState = "";
        if (this.state.letterData && this.state.letterData.origin && this.state.letterData.origin.char) {
            reportAPI = DefaultService.updateNotSee;
            id.push(this.state.letterData.origin.char);
            strChangeState = this.state.letterData.origin.char+":"+LetterStateManager.StateNotSee+":0";
        } else if(this.state.wordData && this.state.wordData.origin && this.state.wordData.origin.chars){
            reportAPI = DefaultService.updateNotSee;
            for(var i=0; i<this.state.wordData.origin.chars.length;i++){
                let oneChar = this.state.wordData.origin.chars[i];
                let getState = LetterStateManager.instance().letterState(oneChar);
                if( getState >= LetterStateManager.StatePassed){
                    id.push(oneChar);
                    let strStart=";";
                    if(id===0){
                        strStart = "";
                    }
                    strChangeState = strChangeState + oneChar+":"+LetterStateManager.StateNotSee+":0" + strStart;
                }
            }
       }

        if (reportAPI) {
            id = id.join(",");
            reportAPI({id: id},
                  (response) => {
                      this.setState({showChangeState: false, isChangedState: true});
                      LetterStateManager.instance().updateData(strChangeState, true);
                      MessageBox.success({
                          text: this.props.t("changeStateSuccess"),
                          duration: 5000
                      });
                  },
                  (response) => {
                      this.setState({showChangeState: false, isChangedState: false});
                      MessageBox.danger({
                          text: this.props.t("changeStateError"),
                          duration: 5000
                      });
                  });
        }
        else {
            this.setState({showChangeState: false, isChangedState: false});
        }
    }

    _handlePlayAudio = () => {
        if (this.player && this.Explanation.isModalVisible()) {
            this.setState({ paused: false });
        }
    };

    _handleStopAudio = () => {
        this.setState({ paused: true }, () => {
            this.player.seek(0);
        });
    };

    _handlePlayWordAudio = () => {
        let { syllables, chars } = this.state.wordData.origin;
        if(!chars) return;
        let { useNewPath } = this.state.wordData;

        let fileName = Helper.buildWordAudioName(syllables);

        //使用从json文件中读出来的拼音, 如果有的话
        let newFileName = Helper.buildWordAudioName(this.state.wordData.syllables);
        if (!Helper.isNullOrEmpty(newFileName)) {
            fileName = newFileName;
        }

        const firstCharCode = Helper.getUnicodeOfChineseChar(chars[0], "");
        const oldPath = `~/fs/dictionary/word/audio/${fileName}.mp3`;
        const newPath = `~/fs/dictionary/word/audio/${firstCharCode}/${fileName}.mp3`;
        const path = useNewPath ? newPath : oldPath;
        //console.log(path);
        this.setState(
            {
                audioPath: path,
            },
            () => {
                this._handlePlayAudio();
            }
        );
    };
}
const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
    },
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },
    listContainer: {
        flex: 1,
        padding: 15,
        paddingTop: 0,
    },
    itemTitleStyle: {
        marginBottom: 2,
        fontSize: 18,
        color: "#b6b6b6",
    },
    itemMargin: {
        marginBottom: 10,
    },
    itemTextStyle: {
        color: "#525252",
        fontSize: 13,
        lineHeight: 22,
    },
    itemTextStyleContent: {
        color: "#787878",
        fontSize: 13,
        lineHeight: 22,
    },
    itemStyle: {
        padding: 5,
    },
    issueIcon: {
        fontSize: 24,
        color: "#ffb400",
    }
});

BottomPopExplanationInstance.propTypes = {
    data: PropTypes.object,
};

BottomPopExplanationInstance.defaultProps = {
    data: {
        syllables: [],
        chars: [],
    },
};
const BottomPopExplanationInstanceWrapper = hoistStatics(withTranslation(uid, { withRef: true })(BottomPopExplanationInstance), BottomPopExplanationInstance);

class BottomPopExplanation extends PureComponent {
    render() {
        return null;
    }

    _handleWordExplanationSheet = word => {
        BottomPopExplanationInstanceWrapper.handleWordExplanationSheet(word);
    };

    _handleLetterExplanationSheet = letter => {
        BottomPopExplanationInstanceWrapper.handleLetterExplanationSheet(letter);
    };

    _handleNoData = word => {
        BottomPopExplanationInstanceWrapper.handleNoData(word);
    };
}

BottomPopExplanation.propTypes = {
    data: PropTypes.object,
};

BottomPopExplanation.defaultProps = {
    data: {
        syllables: [],
        chars: [],
    },
};

export default BottomPopExplanation;
export { BottomPopExplanationInstanceWrapper as BottomPopExplanationInstance };
